import { formatUpperCase } from 'src/app/shared/utility/common';

export function buildCampaignDetailsData(campaignDetails, areAllChannelsSelected, isActualMode = false) {
    let campaignDetailsInfo;
    let campaignNumericalMetrics;

    let pricingMethod = campaignDetails.billingMethod == 'PER_HOUR' ? 'CPH' : 'CPM';

    campaignDetailsInfo = [
        { title: 'Brand Name', value: campaignDetails.brandName },
        { title: 'Issuer Name', value: campaignDetails.issuerName },
        { title: 'Pricing Model', value: pricingMethod },
        { title: 'Screens', value: campaignDetails.screens },
        { title: 'Slots', value: campaignDetails.slots }
    ];

    if (campaignDetails.industryName != null) {
        campaignDetailsInfo.push({ title: 'Industry', value: campaignDetails.industryName });
    }

    if (areAllChannelsSelected) {
        campaignDetailsInfo.push({
            title: 'Campaign Status',
            value: formatUpperCase(campaignDetails.status)
        });
    }

    campaignNumericalMetrics = [
        {
            title: 'Unspent Balance',
            price: campaignDetails.unspentBalance,
            iconUrl: './assets/images/icons/analytics/unspent-icon.svg'
        },
        {
            title: 'Spent',
            price: campaignDetails.spentBalance,
            iconUrl: './assets/images/icons/analytics/spent-icon.svg'
        }
    ];

    if (isActualMode) {
        const actualMetrics = [
            {
                title: 'Plays',
                value: campaignDetails.channelsPlays,
                percentage: pricingMethod === 'CPH' ? campaignDetails.playsDiff : null,
                iconUrl: './assets/images/icons/analytics/channels-plays.svg'
            },
            {
                title: 'Impressions',
                value: campaignDetails.estimatedChannelsImpressions,
                percentage: pricingMethod === 'CPM' ? campaignDetails.impressionsDiff : null,
                iconUrl: './assets/images/icons/analytics/impressions.svg'
            },
            {
                title: 'Reach',
                value: campaignDetails.estimatedChannelsReach,
                percentage: pricingMethod === 'CPM' ? campaignDetails.reachDiff : null,
                iconUrl: './assets/images/icons/analytics/reach.svg'
            }
        ];

        actualMetrics.filter(metric => hasMetricData(metric.value)).forEach(metric =>
            campaignNumericalMetrics.push(metric)
        );
    } else {
        if (pricingMethod === 'CPH') {
            campaignNumericalMetrics.push({
                title: 'Plays',
                value: campaignDetails.channelsPlays,
                iconUrl: './assets/images/icons/analytics/channels-plays.svg'
            });
        } else {
            campaignNumericalMetrics.push(
                {
                    title: 'Impressions',
                    value: campaignDetails.estimatedChannelsImpressions,
                    iconUrl: './assets/images/icons/analytics/impressions.svg'
                },
                {
                    title: 'Reach',
                    value: campaignDetails.estimatedChannelsReach,
                    iconUrl: './assets/images/icons/analytics/reach.svg'
                }
            );
        }
    }

    return { campaignDetailsInfo, campaignNumericalMetrics };
}

const hasMetricData = (value: any) =>
    value !== null && value !== undefined && value !== '' && value !== 0 && value !== '0';